<template>
  <div class="trip-info" :class="{'active': showTicket}">
    <TitleInfo
      :departure="trip.cityDepName"
      :arrived="trip.cityArrName"
      :depDate="trip.dtDep | date"
      :passcount="passcount"
      :showTicket="showTicket"
      @showTicket="setShowTicket"
    />
    <Ticket :trip="trip" :key="trip.tripId" inline-template v-show="showTicket">
      <div class="octobus__columns">
        <div class="octobus__column">
          <div class="is-inline-block-touch time-block">
            <span class="time-departure is-block-touch has-text-weight-bold">
              {{ trip.dtDep | time }}
            </span>
            <span class="date-departure is-block-touch">
              {{ trip.dtDep | date}}
            </span>
          </div>
          <div class="is-inline-block-touch">
            <span class="city-departure is-block-touch">
              {{ trip.stDepName}}
            </span>
            <span class="address-departure is-block-touch">
              {{ trip.stDepAddr}}
            </span>
          </div>
        </div>
        <div class="octobus__column duration-block">
          <div class="is-inline-block-touch trip-arrow-div time-block is-size-4 is-hidden-tablet">
            <font-awesome-icon :icon="arrowDownLong" />
          </div>
          <div class="is-inline-block-touch has-text-weight-bold">
            <span class="time-inway">
              {{$t('tripInfo.inway', {wayTimeH: trip.wayTimeH, wayTimeM: trip.wayTimeM})}}
            </span>
          </div>
        </div>
        <div class="octobus__column">
          <div class="is-inline-block-touch time-block">
            <span class="time-arrived is-block-touch has-text-weight-bold">
              {{ trip.dtArr | time}}
            </span>
            <span class="date-arrived is-block-touch">
              {{ trip.dtArr | date}}
            </span>
          </div>
          <div class="is-inline-block-touch">
            <span class="city-arrived is-block-touch">
              {{ trip.stArrName}}
            </span>
            <span class="address-departure is-block-touch">
              {{ trip.stArrAddr}}
            </span>
          </div>
        </div>
      </div>
    </Ticket>
  </div>
</template>

<script>
import moment from 'moment';
import TitleInfo from './TitleInfo';
import Ticket from '../Ticket/Ticket';


export default {
  name: 'TripInfo',
  components: {
    TitleInfo,
    Ticket,
  },
  data() {
    return {
      showTicket: false,
    };
  },
  props: {
    trip: {
      type: Object,
      required: true,
    },
    passcount: {
      type: [String, Number],
      default() {
        return 1;
      },
    },
  },
  methods: {
    setShowTicket(state) {
      this.showTicket = state;
    },
  },
  filters: {
    date(dateSring) {
      return moment(dateSring).format('Do MMMM');
    },
  },
};
</script>

<style scoped lang="scss">
#app, #auth {
  .trip-info {
    padding: 1rem 0;

    &.active {
      // background-color: #f9f9f9;
    }
  }
}
/* Large Devices, Wide Screens */
@media only screen and (min-width : 1024px) {
  #app, #auth {
    .trip-info {
      &.active {
        background-color: inherit;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/TripInfo/TripInfo.vue